import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';

import { UserSelect } from '../../../components/UserSelect/UserSelect';
import { Layout } from '../../../navigation/components/Layout/Layout';
import { UserInfosRequiredCard } from '../../../user/components/UserInfosRequiredCard';
import { HeaderCard } from '../../components/HeaderCard';
import { MilestoneCard } from '../Payment/components/MilestoneCard';
import { OnlinePaymentCard } from '../Payment/components/OnlinePaymentCard/OnlinePaymentCard';
import { usePaymentForSomeone } from './usePaymentForSomeone';

export const PaymentForSomeone: FunctionComponent = () => {
  const {
    currentEvent,
    currentMilestone,
    hasGivenInformation,
    loading,
    nextMilestone,
    onGoToDashboard,
    onGoToPayment,
    pickedUserId,
    setPickedUserId,
    unpaidUsers,
  } = usePaymentForSomeone();

  return (
    <Layout title="Paiement pour quelqu'un d'autre" activeTab="payment">
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <HeaderCard />
          {hasGivenInformation ? (
            currentEvent ? (
              !currentEvent.hasPaidTicket ? (
                <Card>
                  <CardContent>
                    <Typography variant="body2">
                      {`Vous n'avez pas encore payé votre place. Veuillez payer votre propre place avant de payer pour quelqu'un d'autre`}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button variant="contained" onClick={onGoToPayment}>
                      {`S'inscrire`}
                    </Button>
                  </CardActions>
                </Card>
              ) : currentEvent.isFull ? (
                <Card>
                  <CardContent>
                    <Typography variant="body1">
                      {`L'événement est complet. Vous ne pouvez pas payer de place pour d'autres personnes pour le moment.`}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button variant="contained" onClick={onGoToDashboard}>
                      Retourner au Dashboard
                    </Button>
                  </CardActions>
                </Card>
              ) : (
                <>
                  <Card sx={{ mb: 2 }}>
                    <CardContent>
                      <Typography variant="h6">
                        {
                          "Vous avez la possibilité de payer une place pour quelqu'un d'autre. Choisissez quelqu'un dans la liste puis procédez au paiement."
                        }
                      </Typography>
                    </CardContent>
                  </Card>
                  <MilestoneCard
                    currentMilestone={currentMilestone}
                    nextMilestone={nextMilestone}
                  />

                  <Card sx={{ mb: 2 }}>
                    <CardContent>
                      {unpaidUsers.length > 0 ? (
                        <>
                          <UserSelect
                            users={unpaidUsers}
                            onUserSelect={setPickedUserId}
                            selectedUserId={pickedUserId ?? undefined}
                          />
                          <Typography variant="caption" color="textSecondary">
                            {`Si vous ne trouvez pas la personne pour qui vous souhaitez payer, assurez-vous qu'elle s'est inscrite à l'événement sans encore avoir payé sa place.`}
                          </Typography>
                        </>
                      ) : (
                        <Typography variant="body1">
                          {`Il n'y a actuellement personne pour qui vous pouvez payer une place.`}
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                  {currentMilestone && pickedUserId ? (
                    <OnlinePaymentCard
                      event={currentEvent}
                      milestone={currentMilestone}
                      payForUserId={pickedUserId}
                    />
                  ) : null}
                </>
              )
            ) : null
          ) : (
            <UserInfosRequiredCard />
          )}
        </>
      )}
    </Layout>
  );
};
